var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStars(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 233,
    height: 40,
    viewBox: "0 0 233 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.333 0L26.2109 11.9098L39.3541 13.8197L29.8436 23.0902L32.0887 36.1803L20.333 30L8.5773 36.1803L10.8224 23.0902L1.31188 13.8197L14.4552 11.9098L20.333 0Z",
    fill: "#F6A632"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M68.333 0L74.2109 11.9098L87.3541 13.8197L77.8436 23.0902L80.0887 36.1803L68.333 30L56.5773 36.1803L58.8224 23.0902L49.3119 13.8197L62.4552 11.9098L68.333 0Z",
    fill: "#F6A632"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M116.333 0L122.211 11.9098L135.354 13.8197L125.844 23.0902L128.089 36.1803L116.333 30L104.577 36.1803L106.822 23.0902L97.3119 13.8197L110.455 11.9098L116.333 0Z",
    fill: "#F6A632"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M164.333 0L170.211 11.9098L183.354 13.8197L173.844 23.0902L176.089 36.1803L164.333 30L152.577 36.1803L154.822 23.0902L145.312 13.8197L158.455 11.9098L164.333 0Z",
    fill: "#F6A632"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M212.333 0L218.211 11.9098L231.354 13.8197L221.844 23.0902L224.089 36.1803L212.333 30L200.577 36.1803L202.822 23.0902L193.312 13.8197L206.455 11.9098L212.333 0Z",
    fill: "#F6A632"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStars);
export default __webpack_public_path__ + "static/media/stars.266cc2e3b0be07322aa5c15567e986a2.svg";
export { ForwardRef as ReactComponent };